import AdditionalDetails from "../../../newComponents/AdditionalDetails/AdditionalDetails";
import { EntityType } from "@propertelligent/client-api";
import TenantPaymentMethodTab from "../paymentMethods/TenantPaymentMethodTab";
import TransactionView from "../../../newComponents/transactions/view";
import ServiceRequest from "../../../pages/service-request";
import PastLeaseTabContent from "../../../newComponents/tabs/tabs/tab-pages/pastlease-tab-content";
import { TenantPaymentsTabContent } from "../ManageAutoPay";
import SimpleSpinner from "../../../components/loader";
import "./tenantDashboardTabs.css";

export const getTenantDashboardTabs = (
  filteredRows: any[],
  loading: boolean,
  fetchData: (page?: number) => void,
  sentryRef: (node?: Element | null) => void,
  setActiveTab: (id: string) => void,
  selectedFilter: string,
  tenantId?: number,
  unitId?: number,
  activeTab?: string,
  menuItems?: any
) => [
  // ---------------- Payments ----------------
  {
    id: "payments",
    label: "Payments",
    content:
      activeTab === "payments" ? (
        <div className="tenant-tab-content-loader-wrapper">
          {loading ? (
            <div className="tab-loader-centered">
              <SimpleSpinner myClassName="Icon50" />
            </div>
          ) : (
            <TenantPaymentsTabContent
              filteredRows={filteredRows}
              loading={loading}
              fetchData={fetchData}
              sentryRef={sentryRef}
              selectedFilter={selectedFilter}
              menuItems={menuItems}
              tenantId={tenantId}
            />
          )}
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Service Requests ----------------
  {
    id: "services_requests",
    label: "Service Requests",
    content:
      activeTab === "services_requests" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-list-wrapper">
          <ServiceRequest
            isEntity={true}
            entityTypeId={EntityType.Tenant}
            entityId={Number(tenantId)}
            tenantUnitId={unitId}
            userRole="Tenant"
            parentClassName="tenant-service-request-parent"
            className="tenant-service-request"
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Transactions ----------------
  {
    id: "transactions",
    label: "Transactions",
    content:
      activeTab === "transactions" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-transaction-list">
          <TransactionView
            isEntity={true}
            entityId={tenantId}
            entityTypeId={EntityType.Tenant}
            tenatPadding="tenant-transactionHeader"
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Leases ----------------
  {
    id: "leases",
    label: "Leases",
    content:
      activeTab === "leases" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-list-wrapper">
          <PastLeaseTabContent
            id={tenantId}
            tenatClassName="tenant-past-lease-tab"
            entityType={EntityType.Tenant}
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Payment Method ----------------
  {
    id: "payment_method",
    label: "Payment Method",
    content:
      activeTab === "payment_method" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-list-wrapper">
          <TenantPaymentMethodTab
            tenantId={tenantId}
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Additional Details ----------------
  {
    id: "additional_details",
    label: "Additional Details",
    content:
      activeTab === "additional_details" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-list-wrapper">
          <AdditionalDetails
            entityId={tenantId}
            entityTypeId={EntityType.Tenant}
            isPadding={false}
            userRole="Tenant"
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },
];
